import { render, staticRenderFns } from "./VerificationSuccess.vue?vue&type=template&id=50f02810&scoped=true&"
import script from "./VerificationSuccess.vue?vue&type=script&lang=js&"
export * from "./VerificationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./VerificationSuccess.vue?vue&type=style&index=0&id=50f02810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f02810",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VLayout,VRow})
